<div class="daxa-dialog-inner">

    <!-- Header -->
    <div class="dialog-header d-flex align-items-center justify-content-between">
        <h5 class="mb-0">
            <i class="ri-edit-line me-2"></i> Edit Profile
        </h5>
        <button mat-icon-button mat-dialog-close class="close-btn">
            <i class="ri-close-line"></i>
        </button>
    </div>

    <!-- Body -->
    <mat-dialog-content>
        <form [formGroup]="editForm" class="edit-profile-form">
            <div class="row">
                <div class="col-sm-6">
                    <div class="mb-20">
                        <mat-form-field appearance="fill">
                            <mat-label>First name</mat-label>
                            <input matInput formControlName="first_name" placeholder="First name">
                            <mat-error *ngIf="editForm.get('first_name')?.hasError('required')">
                                First name is required
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="mb-20">
                        <mat-form-field appearance="fill">
                            <mat-label>Last name</mat-label>
                            <input matInput formControlName="last_name" placeholder="Last name">
                            <mat-error *ngIf="editForm.get('last_name')?.hasError('required')">
                                Last name is required
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-sm-12">
                    <div class="mb-20">
                        <mat-form-field appearance="fill">
                            <mat-label>Email address</mat-label>
                            <input matInput formControlName="email" placeholder="Email address" type="email">
                            <mat-error *ngIf="editForm.get('email')?.hasError('required')">
                                Email is required
                            </mat-error>
                            <mat-error *ngIf="editForm.get('email')?.hasError('email')">
                                Enter a valid email address
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>

        </form>
    </mat-dialog-content>

    <!-- Footer -->
    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close class="btn-cancel">Cancel</button>
        <button mat-button class="btn-save" (click)="save()" [disabled]="saving">
            <span *ngIf="!saving"><i class="ri-check-line me-1"></i> Save Changes</span>
            <span *ngIf="saving">Saving...</span>
        </button>
    </mat-dialog-actions>

</div>